export default __webpack_public_path__ + "static/media/Licenses_Shapes-01.ba26f1c5.png";